import React, { useEffect, useState } from 'react';
import HorizontalDescriptionEspot from '../HorizontalDescriptionEspot/HorizontalDescriptionEspot';
import AfterPayMessaging from '../AfterPayMessaging/AfterPayMessaging';
import { PayPalScriptProvider, PayPalMessages } from '@paypal/react-paypal-js';

export function ProductMisc(props) {
  const [isLoading, setIsLoading] = useState(true);

  //Paypal Messages Styling
  const style = {
    layout: 'text',
    logo: { type: 'inline', position: 'right' },
    text: { color: 'monochrome', size: '16' },
  };

  useEffect(() => {
    setTimeout(() => {
      //Fix styles being injected into the Shadow Dom by AfterPay
      document.querySelectorAll('afterpay-placement').forEach((host) => {
        if (host !== null && host.shadowRoot !== null) {
          var style = document.createElement('style');
          style.setAttribute('id', 'afterpayStyles');
          style.innerHTML =
            '.afterpay-main-text{ margin-right: 4px !important;} .afterpay-logo.brand-afterpay, .afterpay-logo.brand-afterpay svg{ width: 88px !important;} .afterpay-logo.brand-afterpay{ margin: 0 !important;} .cashappafterpay-modal-link-wrapper{ display: inline-block !important;} .afterpay-logo-link{ white-space: unset;}';
          if (host.shadowRoot !== null) {
            if (host.shadowRoot.querySelector('.afterpay-main-text')) {
              if (host.shadowRoot.querySelector('.afterpay-main-text').innerText.indexOf('or') > -1) {
                var afterpayMessageText = host.shadowRoot.querySelector('.afterpay-main-text').innerText.slice(3);
                host.shadowRoot.querySelector('.afterpay-main-text').innerText = afterpayMessageText;
              }
            }
            host.shadowRoot.querySelector('.afterpay-link').innerHTML = 'Learn More';
            host.shadowRoot.querySelector('.afterpay-link').style.textDecoration = 'underline';
            //Check if style tag is already there - if not, add it
            var afterpayStyles = host.shadowRoot.getElementById('afterpayStyles');
            if (typeof afterpayStyles === 'undefined' || afterpayStyles === null) {
              host.shadowRoot.appendChild(style);
            }
          }
        }
      });
      var overlays = document.querySelectorAll('.overlay');
      overlays.forEach(function (overlay) {
        overlay.classList.remove('overlay');
      });

      setIsLoading(false);
    }, 1000);
  });

  return (
    <>
      {props.isBundle == true ? (
        ''
      ) : (
        <div
          className={
            isLoading ? 'skeleton product-misc hide-when-international' : 'product-misc hide-when-international'
          }
        >
          {props.showHorizonatalEspot === false ? '' : <HorizontalDescriptionEspot contentData={props.contentData} />}
          {props.isQuickView == null &&
            !props.previewItem &&
            !(props.contentData && props.contentData.pricing && props.contentData.pricing.dept == '0968') &&
            (props.contentData.unavailableMessage == '' ||
              typeof props.contentData.unavailableMessage == 'undefined') &&
            Number(props.contentData.pricing.offerPriceMax.split(',').join('')) <= 1500 && (
              <div
                className={
                  props.passedAppFunctions.wasParms.afterpayMaxOrderAmt ? 'pp-messaging no-afterpay' : 'pp-messaging'
                }
              >
                {props.passedAppFunctions.wasParms.payPalClientId ? (
                  <PayPalScriptProvider
                    options={{ 'client-id': props.passedAppFunctions.wasParms.payPalClientId, components: 'messages' }}
                  >
                    <PayPalMessages
                      style={style}
                      forceReRender={[style]}
                      amount={props.contentData.pricing.offerPriceMax.split(',').join('')}
                    />
                  </PayPalScriptProvider>
                ) : (
                  ''
                )}

                {props.contentData.pricing &&
                  Number(props.contentData.pricing.offerPriceMax.split(',').join('')) <=
                    Number(props.passedAppFunctions.wasParms.afterpayMaxOrderAmt) && (
                    <p className={isLoading == 'BundleDisplay' ? 'hide-p' : ''}>or</p>
                  )}
              </div>
            )}
          {props.isQuickView == null &&
            !props.previewItem &&
            (props.contentData.unavailableMessage == '' ||
              typeof props.contentData.unavailableMessage == 'undefined') && (
              <AfterPayMessaging pricing={props.contentData.pricing} passedAppFunctions={props.passedAppFunctions} />
            )}
        </div>
      )}
    </>
  );
}

export default ProductMisc;
